export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-superscript-13d17725e766f748048e514efc677f16.svg";